module.exports = __webpack_public_path__ + "static/assets/8969372a821bd2a0170ed9a68a3e238d.png";